module.exports = __webpack_public_path__ + "static/media/createCourseRequestSent.99fef3b2.svg";